import React from 'react';
import LetterVisual from './LetterVisual';
import OpenWhenVisual from './OpenWhenVisual';
import VoiceVisual from './VoiceVisual';
import { FrameGalleryVisual, PhotoVisual, ThenNowVisual } from './PhotoVisual';
import TimelineVisual from './TimelineVisual';
import BlessingVisual from './BlessingVisual';
import KeepsakeVisual from './KeepsakeVisual';
import MapVisual from './MapVisual';
import MuseumVisual from './MuseumVisual';
import PolaroidVisual from './PolaroidVisual';

const SongVisual = () => (
  <span className="lumirae-layer-visual lumirae-layer-visual-song" aria-hidden="true">
    <span className="record" />
    <span className="sleeve">
      <i />
      <b />
    </span>
  </span>
);

const StudioVisual = () => (
  <span className="lumirae-layer-visual lumirae-layer-visual-studio" aria-hidden="true">
    <span className="page">
      <i />
      <i />
      <i />
    </span>
    <span className="spark spark-a" />
    <span className="spark spark-b" />
  </span>
);

const DefaultVisual = () => (
  <span className="lumirae-layer-visual lumirae-layer-visual-default" aria-hidden="true">
    <span className="box" />
    <span className="lid" />
    <span className="ribbon vertical" />
    <span className="ribbon horizontal" />
  </span>
);

const VISUALS = {
  letter: LetterVisual,
  envelope: OpenWhenVisual,
  voice: VoiceVisual,
  photo: PhotoVisual,
  gallery: FrameGalleryVisual,
  compare: ThenNowVisual,
  timeline: TimelineVisual,
  blessing: BlessingVisual,
  keepsake: KeepsakeVisual,
  map: MapVisual,
  museum: MuseumVisual,
  polaroid: PolaroidVisual,
  music: SongVisual,
  studio: StudioVisual,
};

export const getRevealVisual = (tone) => VISUALS[tone] || DefaultVisual;

export default VISUALS;
